import { render, staticRenderFns } from "./Unbind.vue?vue&type=template&id=60bc600f&scoped=true&"
import script from "./Unbind.vue?vue&type=script&lang=js&"
export * from "./Unbind.vue?vue&type=script&lang=js&"
import style0 from "./Unbind.vue?vue&type=style&index=0&id=60bc600f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bc600f",
  null
  
)

export default component.exports